// helpers for persisting workflow and execution state to localStorage

const WORKFLOW_KEY = "active_workflow";

export function saveWorkflow(workflow) {
  try {
    localStorage.setItem(WORKFLOW_KEY, JSON.stringify(workflow));
  } catch (err) {
    console.error("Failed to save workflow", err);
  }
}

export function loadWorkflow() {
  try {
    const txt = localStorage.getItem(WORKFLOW_KEY);
    return txt ? JSON.parse(txt) : null;
  } catch (err) {
    console.error("Failed to load workflow", err);
    return null;
  }
}

export function clearWorkflow() {
  localStorage.removeItem(WORKFLOW_KEY);
}

export function saveState(state) {
  return state;
}

export function loadState() {
  return null;
}

export function clearState() {
  // execution state is now persisted in DB for /workflow-runner/:runId mode
}
